<template>
  <div class="">
    <div class="col-12 text-left">
      <router-link :to="{ name: 'TagsDashboard', }" class="">
        <button class="btn mx-1 rounded-pill btn-primary">تگ ها</button>
      </router-link>
    </div>

    <tag-form :submit-function="updateTag"  mode="update" />
  </div>
</template>

<script>
import TagForm from "@/plugin/components/dashboard/Tag/TagForm.vue";
import {mapActions} from "vuex";

export default {
  name: "updateTag",
  components: {TagForm},
  methods:{
    ...mapActions({
      updateTag: 'Tag/updateTag'
    })
  }
}
</script>

<style scoped>

</style>